import React, { useState, useRef } from "react";
import LinkButton from "./LinkButton";
//Import Icons
import SearchIcon from "../../images/SearchIcon.svg";
import clearTextIcon from "../../images/clearTextIcon.svg";
//Import styles
import "./RoundedSearchTextField.scss";

const RoundedSearchTextField = ({
  inlineButton = false,
  placeholder = "Search...",
  onTextChange,
  handleSearch,
  isResetClicked,
  expandable,
  inputValue = "",
  handleCrossIcon,
  fetchAllTemplates,
  setIsSearchBarEmpty,
  isSearchBarEmpty,
}) => {
  const searchButtonRef = useRef("");
  const [isFocused, setIsFocused] = useState(false);
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
  };
  const clearTextField = () => {
    const element = document.getElementById("tf-search-field");
    if (element) {
      element.value = "";
      setIsSearchBarEmpty(true);
      onTextChange(element.value);
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(event);
    }
  };
  const handleSearchClick = (event) => {
    handleSearch(event);
  };
  return (
    <div className={`tf-rounded-search ${expandable ? "expandable" : ""}`}>
      <div className="d-flex align-items-center">
        <img src={SearchIcon} alt="" className="search-icon" />
        <input
          id="tf-search-field"
          type="text"
          value={inputValue || ""}
          placeholder={placeholder}
          className="search-input"
          autoComplete="off"
          onKeyPress={handleKeyPress}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onDrop={(e) => e.preventDefault()}
          onChange={(e) => {
            if (e.target.value?.trim().length > 0) {
              setIsSearchBarEmpty(false);
            } else {
              setIsSearchBarEmpty(true);
            }
            onTextChange(e.target.value);
          }}
        />

        {inlineButton && (
          <LinkButton
            ref={searchButtonRef}
            className=""
            handleClick={(event) => {
              handleSearchClick(event);
            }}
            disabled={isSearchBarEmpty}
            title="SEARCH"
            height="32px"
          />
        )}

        {!isSearchBarEmpty && (
          <img
            src={clearTextIcon}
            alt=""
            className=""
            style={{ cursor: "pointer" }}
            onClick={(event) => {
              clearTextField();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default RoundedSearchTextField;
